export default {
  scenes: {
    diplomaticMission: {
      beats: {
        newAssignment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'commandCenter'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'A new mission: to travel to a distant planet embroiled in conflict. The goal is to negotiate peace between two warring factions and establish a lasting alliance.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'The mission is vital to the future of the galaxy, and Elena is determined to succeed. However, there are risks, both political and personal.',
              choices: [
                {
                  text: 'Lead with Confidence',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'leadWithConfidence'
                  }
                },
                {
                  text: 'Lead with Caution',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'leadWithCaution'
                  }
                }
              ]
            }
          ]
        },
        leadWithConfidence: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'This is our chance to make a real difference. We\'ve faced tougher challenges before, and we\'ll handle this one the same way—together.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Let\'s do it, Captain.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'tensionsOnThePlanet'
          }
        },
        leadWithCaution: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'This won\'t be easy. We need to approach this carefully and make sure we don\'t make things worse.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'I agree. It\'s delicate, but we\'ll follow your lead, Elena.'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'tensionsOnThePlanet'
          }
        },
        tensionsOnThePlanet: {
          events: [
            {
              type: 'showLocation',
              locationId: 'conflictPlanet'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Arriving on the planet, Elena and her team quickly realize that the situation is far more volatile than they anticipated. Both factions are distrustful of outsiders, and their negotiations have been tense at best.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'Elena tries to balance diplomacy with firmness, but it\'s clear that some people on the planet want war, not peace. As tensions rise, Elena faces her first real challenge in this new phase of her journey.',
              choices: [
                {
                  text: 'Stay Calm and Neutral',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'stayCalm'
                  }
                },
                {
                  text: 'Confront the Extremists',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'confrontExtremists'
                  }
                }
              ]
            }
          ]
        },
        stayCalm: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'re not here to take sides; we\'re here to help you find common ground. Let\'s take a step back and try again.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'This isn\'t going to be easy.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'unexpectedAllies'
          }
        },
        confrontExtremists: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'If you want peace, you need to stop threatening each other. We won\'t tolerate any more aggression.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Careful, Elena. This could get us in trouble.'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'unexpectedAllies'
          }
        },
        unexpectedAllies: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'neutral',
              text: 'In the midst of the heated negotiations, a surprise ally emerges—a former military officer named Orion, who had once fought for peace but had since become disillusioned by the ongoing conflict.'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'neutral',
              text: 'He offers to help Elena, sharing valuable intelligence about both factions and their true motives.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'With Orion\'s help, Elena finds a way to gain the trust of the more moderate factions, but she must now decide whether to trust him fully or remain cautious.',
              choices: [
                {
                  text: 'Trust Orion Completely',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'trustOrion'
                  }
                },
                {
                  text: 'Keep a Watchful Eye on Orion',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'watchOrion'
                  }
                }
              ]
            }
          ]
        },
        trustOrion: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'You\'ve got my trust, Orion. Let\'s work together to bring peace.'
            },
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'happy',
              text: 'You won\'t regret this, Captain.'
            },
            {
              type: 'hideCharacter',
              characterId: 'orion',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'secretBetrayal'
          }
        },
        watchOrion: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'We\'ll work together, but I\'m keeping my guard up. Trust is earned, not given freely.'
            },
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'neutral',
              text: 'Fair enough, Captain. I\'ll prove I\'m on your side.'
            },
            {
              type: 'hideCharacter',
              characterId: 'orion',
              position: 'center'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'secretBetrayal'
          }
        },
        secretBetrayal: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'surprised',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'surprised',
              text: 'Just as the team begins to make progress in the negotiations, Elena uncovers a shocking truth: Orion has been feeding both factions misinformation, inciting chaos to further his own goals.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'It\'s a blow to Elena, who feels personally betrayed. The team must now regroup and decide whether to confront Orion or continue the mission without him. The pressure mounts as the future of the galaxy hangs in the balance.',
              choices: [
                {
                  text: 'Confront Orion Immediately',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'confrontOrion'
                  }
                },
                {
                  text: 'Try to Understand Orion\'s Motive First',
                  next: {
                    scene: 'diplomaticMission',
                    beat: 'understandOrion'
                  }
                }
              ]
            }
          ]
        },
        confrontOrion: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'You\'ve been playing both sides! Why?'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'angry',
              text: 'I had my reasons! You don\'t understand.'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'escape'
          }
        },
        understandOrion: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Why, Orion? What are you trying to achieve?'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'sad',
              text: 'I wanted peace, but I lost faith. I thought chaos would force change.'
            }
          ],
          next: {
            scene: 'diplomaticMission',
            beat: 'escape'
          }
        },
        escape: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'The confrontation with Orion escalates, forcing Elena and her team to make a difficult decision. With Orion\'s betrayal threatening the peace process, Elena orders him detained, but not before he escapes with vital information that could change the course of the mission.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'We can\'t let him get away with this. We have to stop him—before he destroys everything we\'ve worked for.'
            }
          ],
          next: {
            scene: 'desperateChase',
            beat: 'pursuit'
          }
        }
      }
    },
    desperateChase: {
      beats: {
        pursuit: {
          events: [
            {
              type: 'showLocation',
              locationId: 'conflictPlanet'
            },
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: -15
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Elena and her team chase after Orion, navigating the dangerous terrain of the planet as they race against time. The pursuit is tense, and every decision Elena makes could mean the difference between success and failure.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'With the information in Orion\'s hands, the fate of the diplomatic mission—and the galaxy itself—hangs in the balance.',
              choices: [
                {
                  text: 'Use Caution and Strategy',
                  next: {
                    scene: 'desperateChase',
                    beat: 'cautionStrategy'
                  }
                },
                {
                  text: 'Take Risks and Pursue Orion Immediately',
                  next: {
                    scene: 'desperateChase',
                    beat: 'takeRisks'
                  }
                }
              ]
            },
            {
              type: 'hideEffect',
              effect: 'motionLines'
            }
          ]
        },
        cautionStrategy: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'We can\'t afford to rush in blindly. We need to plan our next move carefully.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Agreed. Let\'s make sure we don\'t walk into a trap.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'desperateChase',
            beat: 'finalConfrontation'
          }
        },
        takeRisks: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'We don\'t have time to waste. We need to catch up with him now!'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Elena, this could be dangerous. We need to be smart about this.'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'center'
            }
          ],
          next: {
            scene: 'desperateChase',
            beat: 'finalConfrontation'
          }
        },
        finalConfrontation: {
          events: [
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 10,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'orion',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'This ends now, Orion. You can\'t keep playing both sides.'
            },
            {
              type: 'showDialog',
              speaker: 'orion',
              variation: 'sad',
              text: 'I thought I could make a difference. Maybe I was wrong.'
            }
          ],
          goToChapter: {
            chapter: 'chapter7'
          }
        }
      }
    }
  }
}
